export const MODULE = 'SPECIAL_PERMIT_APPLICATION';

export const GET_TRANSACTION = `${MODULE}/get_transaction`;
export const SHOW_TRANSACTION = `${MODULE}/show_transaction`;
export const ASSESS_RECEIPT = `${MODULE}/assess_receipt`;
export const GENERATE_PERMIT = `${MODULE}/generate_permit`;
export const TOGGLE_ASSESSMENT= `${MODULE}/toggle_assessment`;
export const TAG_VEHICLE_UNIT= `${MODULE}/tag_vehicle_unit`;
export const SUBMIT_ASSESSMENT= `${MODULE}/submit_assessment`;
export const UPDATE_FEES= `${MODULE}/update_fees`;
export const TAG_AS_PRINTED_TRANSACTION= `${MODULE}/tag_as_printed_transaction`;
export const TAG_AS_RECEIVED_TRANSACTION= `${MODULE}/tag_as_received_transaction`;

export const SPECIAL_PERMIT_EOR_URL =
  'api/v1/administrators/transaction_histories/special_permits/{id}/preview_or';
export const SPECIAL_PERMIT_EPERMIT_URL =
  'api/v1/administrators/transaction_histories/special_permits/{id}/preview_permit';
